



































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeCadastroMedicoStore from '@/components/Backoffice/Store/BackofficeCadastroMedicoStore'
import { TipoConviteStatusEnum } from '@/types/_'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentBackofficeCadastroMedicoConviteTable extends Vue {
  conviteTableHeaders: any[] = [
    { text: 'Nome', class: 'table-headers', align: 'left', value: 'nome' },
    { text: 'E-mail', class: 'table-headers', align: 'center', value: 'email' },
    { text: 'Status', class: 'table-headers', align: 'center', value: 'status.display' },
    { text: 'Ações', class: 'table-headers', align: 'center', sortable: false },
  ]

  loadDeleteConvite: string = ''
  get loadingDeleteConvite() { return this.loadDeleteConvite }
  set loadingDeleteConvite(value: string) { this.loadDeleteConvite = value }

  conviteIdentifier: string = ''
  get conviteId() { return this.conviteIdentifier }
  set conviteId(value: string) { this.conviteIdentifier = value }

  modalConfirmacao: boolean = false
  get showModalConfirmacao() { return this.modalConfirmacao }
  set showModalConfirmacao(value: boolean) { this.modalConfirmacao = value }

  @Watch('showModalConfirmacao')
  onChangeShowModalConfirmacao(value: boolean) {
    if (!value) this.conviteId = ''
  }

  get getBackofficeCadastroMedicoStore() {
    return getModule(BackofficeCadastroMedicoStore, this.$store)
  }

  loadConvites: boolean = false
  get loadingConvites() { return this.loadConvites }
  set loadingConvites(value: boolean) { this.loadConvites = value }

  get convites() { return this.getBackofficeCadastroMedicoStore.convites }

  get conviteSearch() { return this.getBackofficeCadastroMedicoStore.conviteSearch }
  set conviteSearch(value: string) { this.getBackofficeCadastroMedicoStore.setConviteSearch(value) }

  displayStatus(tipo: TipoConviteStatusEnum) {
    switch (tipo) {
      case TipoConviteStatusEnum.Reenviado:
        return { text: 'Reenviado', color: '#3949AB' }
      case TipoConviteStatusEnum.CadastroIniciado:
        return { text: 'Cadastro Iniciado', color: '#FF8F00' }
      case TipoConviteStatusEnum.CadastroConcluido:
        return { text: 'Cadastro Concluído', color: '#43A047' }
      case TipoConviteStatusEnum.CadastroEmProcessamento:
        return { text: 'Cadastro em Processamento', color: '#FBC02D' }
      case TipoConviteStatusEnum.Erro:
        return { text: 'Erro ao processar convite', color: '#AD1457' }
      default:
        return { text: 'Enviado', color: '#0097A7' }
    }
  }

  showConfirmationModal(id: string) {
    this.conviteId = id
    this.showModalConfirmacao = true
  }

  async deletarConvite(id: string) {
    this.loadingDeleteConvite = id
    const response = await this.getBackofficeCadastroMedicoStore.deletarConvite(id)
    if (response.success) await this.getBackofficeCadastroMedicoStore.getConvites()
    this.loadingDeleteConvite = ''
  }

  async resend() {
    this.getBackofficeCadastroMedicoStore.setDisableOnResend(true)
    const response = await this.getBackofficeCadastroMedicoStore.resendConvite(this.conviteId)

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Convite reenviado!', icon: 'done', color: '#2E7D32' })
      this.showModalConfirmacao = false
    } else {
      EventBus.$emit('formConviteReset', true)
      EventBus.$emit('setSnackbar', { show: true, text: 'Ocorreu um erro ao reenviar o convite.', icon: 'warning', color: '#C62828' })
      this.conviteId = ''
    }

    this.getBackofficeCadastroMedicoStore.setDisableOnResend(false)
  }
}
